import mod from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--4!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--4!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/services/index.vue?vue&type=script&lang=js&
// module id = 611
// module chunks = 0